import { QueryClient } from '@tanstack/react-query'

import { ApiError } from '@/lib/api'

/**
 * Konfigurasi cache bersama.
 *
 * Permintaan yang ditolak karena aturan — 4xx — tidak diulang: mengulang
 * permintaan yang salah tidak akan membuatnya benar, dan pada endpoint uang
 * pengulangan otomatis justru berbahaya. Hanya galat jaringan dan 5xx yang
 * dicoba ulang.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status < 500) return false
          return failureCount < 2
        },
      },
      mutations: {
        retry: false,
      },
    },
  })
}
